import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaHover from './VaHover.vue'

export const VaHover = withConfigTransport(_VaHover)
